import { defineWave } from '../schema';

/** RESPIRATION — quatre secondes, zéro ennemi.
 *
 *  Ce fichier vide est l'un des plus importants du niveau.
 *
 *  Aucun bloc de combat ne doit dépasser 60 secondes (PLAN.md §6.11) :
 *  l'intensité constante « se fond en bouillie » et épuise le joueur, qui ne
 *  perçoit plus la structure de ce qu'il traverse. Les respirations sont ce qui
 *  rend les pics lisibles COMME des pics — sans elles, il n'y a pas de pic, il
 *  n'y a qu'un niveau sonore.
 *
 *  C'est aussi le moment où le joueur ramasse ce qui traîne et se replace. */
export default defineWave({
  id: 'respiration',
  duration: 4,
  spawns: [],
});
